(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wd-delivery-schedule"] && !Shopify.designMode) return;
  try {
    function initializeWeirdoughDeliverySchedule(root){
  if(!root||root.dataset.deliveryReady==='true')return;
  root.dataset.deliveryReady='true';
  var input=root.querySelector('[data-wd-delivery-date]');
  var slotInput=root.querySelector('[data-wd-delivery-slot]');
  var error=root.querySelector('[data-wd-delivery-error]');
  var earliestText=root.querySelector('[data-wd-earliest]');
  var calendarToggle=root.querySelector('[data-wd-calendar-toggle]');
  var calendarPanel=root.querySelector('[data-wd-calendar]');
  var calendarDays=root.querySelector('[data-wd-calendar-days]');
  var calendarMonthText=root.querySelector('[data-wd-calendar-month]');
  var calendarPrev=root.querySelector('[data-wd-calendar-prev]');
  var calendarNext=root.querySelector('[data-wd-calendar-next]');
  if(!input)return;

  var allowedDays=(root.dataset.allowedDays||'0,2,3,4,5,6').split(',').map(Number);
  var leadDays=Number(root.dataset.leadDays||0);
  var cutoffHour=Number(root.dataset.cutoffHour||0);
  var timeZone=root.dataset.timeZone||'Asia/Kolkata';
  var blockedDates=(root.dataset.blockedDates||'').split(',').map(function(d){return d.trim();}).filter(Boolean);

  function indiaNowParts(){
    var formatter=new Intl.DateTimeFormat('en-CA',{timeZone:timeZone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'});
    var parts={};
    formatter.formatToParts(new Date()).forEach(function(part){if(part.type!=='literal')parts[part.type]=part.value;});
    return {year:Number(parts.year),month:Number(parts.month),day:Number(parts.day),hour:Number(parts.hour),minute:Number(parts.minute)};
  }
  function dateFromParts(parts){return new Date(Date.UTC(parts.year,parts.month-1,parts.day,12,0,0));}
  function addDays(date,days){var next=new Date(date.getTime());next.setUTCDate(next.getUTCDate()+days);return next;}
  function iso(date){return date.toISOString().slice(0,10);}
  function isAllowed(date){return allowedDays.indexOf(date.getUTCDay())!==-1&&blockedDates.indexOf(iso(date))===-1;}
  function nextAllowed(date){var candidate=new Date(date.getTime());var guard=0;while(!isAllowed(candidate)&&guard<14){candidate=addDays(candidate,1);guard+=1;}return candidate;}
  function earliestDate(){
    var now=indiaNowParts();
    var earliest=addDays(dateFromParts(now),leadDays);
    if(cutoffHour>0&&now.hour>=cutoffHour)earliest=addDays(earliest,1);
    return nextAllowed(earliest);
  }
  function readable(date){return new Intl.DateTimeFormat('en-IN',{timeZone:'UTC',weekday:'short',day:'numeric',month:'short'}).format(date);}
  function readableLong(date){return new Intl.DateTimeFormat('en-IN',{timeZone:'UTC',weekday:'long',day:'numeric',month:'long',year:'numeric'}).format(date);}
  function isToday(date,now){return iso(date)===iso(dateFromParts(now));}
  var firstAvailable=earliestDate();
  var calendarCursor=new Date(Date.UTC(firstAvailable.getUTCFullYear(),firstAvailable.getUTCMonth(),1,12,0,0));
  function renderCalendar(){
    if(!calendarDays||!calendarMonthText)return;
    var year=calendarCursor.getUTCFullYear();
    var month=calendarCursor.getUTCMonth();
    calendarMonthText.textContent=new Intl.DateTimeFormat('en-IN',{timeZone:'UTC',month:'long',year:'numeric'}).format(calendarCursor);
    calendarDays.innerHTML='';
    var firstDay=new Date(Date.UTC(year,month,1,12,0,0)).getUTCDay();
    var daysInMonth=new Date(Date.UTC(year,month+1,0,12,0,0)).getUTCDate();
    for(var blank=0;blank<firstDay;blank+=1){var spacer=document.createElement('span');spacer.className='wd-delivery-calendar__blank';calendarDays.appendChild(spacer);}
    for(var day=1;day<=daysInMonth;day+=1){
      var date=new Date(Date.UTC(year,month,day,12,0,0));
      var button=document.createElement('button');
      button.type='button';
      button.textContent=String(day);
      button.setAttribute('aria-label',readableLong(date));
      button.setAttribute('aria-pressed',input.value===iso(date)?'true':'false');
      button.disabled=date<firstAvailable||!isAllowed(date);
      if(!button.disabled)button.addEventListener('click',function(chosen){return function(){
        input.value=iso(chosen);
        calendarToggle.textContent=readableLong(chosen);
        calendarPanel.hidden=true;
        calendarToggle.setAttribute('aria-expanded','false');
        setSlotOptions();
        validate();
        renderCalendar();
      };}(date));
      calendarDays.appendChild(button);
    }
    if(calendarPrev){var earliestMonth=new Date(Date.UTC(firstAvailable.getUTCFullYear(),firstAvailable.getUTCMonth(),1,12,0,0));calendarPrev.disabled=calendarCursor<=earliestMonth;}
  }
  function setSlotOptions(){
    if(!slotInput)return;
    var previous=slotInput.value;
    slotInput.innerHTML='';
    var placeholder=document.createElement('option');
    placeholder.value='';
    placeholder.textContent=root.dataset.slotPlaceholder||'Choose a delivery time';
    slotInput.appendChild(placeholder);
    slotInput.disabled=!input.value;
    if(!input.value)return;
    var chosen=new Date(input.value+'T12:00:00Z');
    var day=chosen.getUTCDay();
    var now=indiaNowParts();
    var today=isToday(chosen,now);
    var slots=[];
    if(day===6){
      if(!today||now.hour<16)slots.push(root.dataset.saturdayEveningSlot||'4–9 PM');
    }else if(day===0){
      if(!today||now.hour<13)slots.push(root.dataset.sundayLunchSlot||'1–3 PM');
      if(!today||now.hour<17)slots.push(root.dataset.eveningSlot||'5–9 PM');
    }
    slots.forEach(function(label){var option=document.createElement('option');option.value=label;option.textContent=label;slotInput.appendChild(option);});
    if(slots.indexOf(previous)!==-1)slotInput.value=previous;
  }
  function validate(){
    var earliest=earliestDate();
    input.min=iso(earliest);
    if(earliestText)earliestText.textContent=(root.dataset.earliestPrefix||'First available:')+' '+readable(earliest);
    var message='';
    if(!input.value)message=root.dataset.requiredMessage||'';
    else{
      var chosen=new Date(input.value+'T12:00:00Z');
      if(chosen<earliest)message=root.dataset.tooEarlyMessage||'';
      else if(!isAllowed(chosen))message=root.dataset.unavailableMessage||'';
    }
    input.setCustomValidity(message);
    var slotMessage='';
    if(slotInput&&input.value&&!message){
      if(slotInput.options.length<=1)slotMessage=root.dataset.slotUnavailableMessage||'';
      else if(!slotInput.value)slotMessage=root.dataset.slotRequiredMessage||'';
    }
    if(slotInput)slotInput.setCustomValidity(slotMessage);
    if(!message&&slotMessage)message=slotMessage;
    if(error){error.textContent=message;error.hidden=!message;}
    return !message;
  }
  input.addEventListener('change',function(){setSlotOptions();validate();if(input.validationMessage&&!calendarToggle)input.reportValidity();});
  if(slotInput)slotInput.addEventListener('change',function(){validate();if(slotInput.validationMessage)slotInput.reportValidity();});
  var form=input.form;
  if(calendarToggle&&calendarPanel){
    calendarToggle.addEventListener('click',function(){var open=calendarPanel.hidden;calendarPanel.hidden=!open;calendarToggle.setAttribute('aria-expanded',open?'true':'false');if(open)renderCalendar();});
    if(calendarPrev)calendarPrev.addEventListener('click',function(){calendarCursor=new Date(Date.UTC(calendarCursor.getUTCFullYear(),calendarCursor.getUTCMonth()-1,1,12,0,0));renderCalendar();});
    if(calendarNext)calendarNext.addEventListener('click',function(){calendarCursor=new Date(Date.UTC(calendarCursor.getUTCFullYear(),calendarCursor.getUTCMonth()+1,1,12,0,0));renderCalendar();});
    renderCalendar();
  }
  if(form)form.addEventListener('submit',function(event){if(!validate()){event.preventDefault();if(input.validationMessage){if(calendarToggle){calendarToggle.focus();calendarPanel.hidden=false;calendarToggle.setAttribute('aria-expanded','true');renderCalendar();}else{input.reportValidity();input.focus();}}else if(slotInput){slotInput.reportValidity();slotInput.focus();}}});
  setSlotOptions();
  validate();
}
document.querySelectorAll('[data-wd-delivery-schedule]').forEach(initializeWeirdoughDeliverySchedule);
document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('[data-wd-delivery-schedule]').forEach(initializeWeirdoughDeliverySchedule);});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wd-gift-details"] && !Shopify.designMode) return;
  try {
    function initializeWeirdoughGiftFlow(root){
  if(!root||root.dataset.giftReady==='true')return;
  root.dataset.giftReady='true';
  var toggle=root.querySelector('[data-wd-gift-toggle]');
  var panel=root.querySelector('[data-wd-gift-details]');
  var fields=Array.prototype.slice.call(root.querySelectorAll('[data-wd-gift-field]'));
  var requiredFields=Array.prototype.slice.call(root.querySelectorAll('[data-wd-gift-required]'));
  if(!toggle||!panel)return;

  function syncGiftFlow(){
    var open=toggle.checked;
    panel.hidden=!open;
    toggle.setAttribute('aria-expanded',open?'true':'false');
    fields.forEach(function(field){field.disabled=!open;});
    requiredFields.forEach(function(field){field.required=open;});
  }
  toggle.addEventListener('change',syncGiftFlow);
  syncGiftFlow();
}
document.querySelectorAll('[data-wd-gift-flow]').forEach(initializeWeirdoughGiftFlow);
document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('[data-wd-gift-flow]').forEach(initializeWeirdoughGiftFlow);});
  } catch(e) { console.error(e); }
})();

})();
